import { createFileRoute } from "@tanstack/react-router";
import { ServiceLayout } from "@/components/ServiceLayout";
import { img } from "@/lib/images";
import { canonicalLinks, routeMeta } from "@/lib/seo";

export const Route = createFileRoute("/services/bookkeeping")({
  head: () => ({
    meta: [
      ...routeMeta("/services/bookkeeping"),
      { title: "Winter Garden Bookkeeping Services | CCOB" },
      { name: "description", content: "Accurate, monthly bookkeeping for Winter Garden small businesses — reconciled books, clean reports, and audit-ready records." },
      { property: "og:title", content: "Bookkeeping Services — CCOB And Company PA" },
      { property: "og:description", content: "Accurate monthly bookkeeping that keeps your records audit-ready." },
    ],
    links: canonicalLinks("/services/bookkeeping"),
  }),
  component: () => (
    <ServiceLayout
      eyebrow="Bookkeeping"
      title="Bookkeeping That Keeps Your Business Audit-Ready"
      subtitle="Reconciled monthly. Reported clearly. Always current."
      hero={img.heroAccounting}
      image={img.accounting}
      intro="Stop chasing receipts and second-guessing your numbers. Our bookkeeping team handles reconciliations, categorization, and monthly close — so you walk into every meeting (and every tax season) with clean, current books."
      items={[
        { title: "Monthly Reconciliations", desc: "Bank, credit card, and merchant accounts reconciled every month — no surprises at year-end." },
        { title: "Accurate Categorization", desc: "Every transaction coded correctly so your P&L actually reflects how the business is performing." },
        { title: "Accounts Payable & Receivable", desc: "We track who owes you, who you owe, and when — keeping cash flow predictable." },
        { title: "Monthly Financial Reports", desc: "Profit & loss, balance sheet, and cash flow statements delivered on a fixed schedule." },
        { title: "QuickBooks Online Setup", desc: "Cloud-based bookkeeping with secure, anywhere access for you and your team." },
        { title: "Year-End Close & Tax Handoff", desc: "Books wrapped and tied to your tax return — no scramble in March." },
      ]}
    />
  ),
});
